
import React, { useEffect, useRef } from 'react';
import { Button } from "@mui/material";
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { useNavigate } from "react-router-dom";

const LSystems = () => {
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const sketchInstanceRef = useRef(null);

  useEffect(() => {
    // El contenedor ya existe en este punto (useEffect corre después del
    // primer render), así que no hay carrera con p5: nosotros decidimos
    // cuándo se crea el sketch, no al revés.
    if (containerRef.current && window.createLSystemSketch) {
      sketchInstanceRef.current = window.createLSystemSketch(containerRef.current);
    } else {
      console.error(
        "InteractApp.js no está cargado todavía (window.createLSystemSketch no existe)."
      );
    }

    // Limpieza: p5 elimina el canvas y TODOS los elementos que creó
    // (botones, sliders, inputs) dentro de este contenedor.
    return () => {
      if (sketchInstanceRef.current) {
        sketchInstanceRef.current.remove();
        sketchInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div>
      <Button onClick={() => navigate(-1)} startIcon={<ArrowBackIosNewOutlinedIcon />}>
        Regresar
      </Button>

      {/* position: relative es necesario porque el sketch posiciona el
          canvas y los controles con coordenadas absolutas dentro de este
          contenedor (en vez de relativas a toda la página, como antes). */}
      <div ref={containerRef} style={{ position: 'relative', minHeight: '600px' }} />
    </div>
  );
};

export default LSystems;





// import React, { useEffect } from 'react'; // Importa React y el hook useEffect
// import { Button } from "@mui/material"; // Importa el componente Button de Material UI
// import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'; // Importa el ícono de flecha hacia atrás de la librería de íconos de Material UI
// import { useNavigate } from "react-router-dom"; // Importa el hook 'useNavigate' para manejar la navegación entre rutas


// const LSystems = () => { // Define el componente funcional Interact
//   const navigate = useNavigate();

//   useEffect(() => { // Hook que se ejecuta cuando el componente se monta
//     // Cambia el estilo de display de los elementos para hacerlos visibles
//     const elements = document.querySelectorAll('.interact'); // Selecciona todos los elementos con la clase 'interact'
//     elements.forEach((element) => { // Itera sobre cada uno de esos elementos
//       element.style.display = 'inline'; // Cambia su display a 'inline' para hacerlos visibles
//     });

//     const canvas = document.querySelector(".p5Canvas"); // Selecciona el canvas con la clase 'p5Canvas'
//     canvas.style.display = "inline"; // Hace visible el canvas cambiando su display a 'inline'

//     // Función de limpieza para restaurar los estilos cuando el componente se desmonte
//     return () => {
//       elements.forEach((element) => { // Itera sobre los elementos con la clase 'interact'
//         element.style.display = ''; // Restaura el estilo de display a su valor por defecto
//       });
//       canvas.style.display = ""; // Restaura el estilo de display del canvas a su valor por defecto
//     };
//   }, []); // Este efecto solo se ejecuta cuando el componente se monta

//   return (
//       <><Button onClick={() => navigate("/apps")}> {/* Botón que redirige a la página principal (ruta "/") al hacer clic */}
//       <ArrowBackIosNewOutlinedIcon /> {/* Muestra el ícono de flecha hacia atrás dentro del botón */}
//     </Button><div> {/* Contenedor vacío que no renderiza nada visualmente */}
//       </div></>
//   );
// };

// export default LSystems; // Exporta el componente Interact